// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2seGy","field":"styles_field__HX9Yk","fieldCol":"styles_fieldCol__1C6zo","diffCol":"styles_diffCol__3Vf_V","diff":"styles_diff__AjFpy"};